import e from"react";import{Container as a,Overlay as l,Spinner as t}from"./styles.js";const r=({className:r})=>e.createElement(a,{"aria-label":"Loading...",role:"status",className:r},e.createElement(l,null),e.createElement(t,null));r.displayName="Loading";export{r as Loading};
//# sourceMappingURL=Loading.js.map
